
import * as React from 'react';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import styled from 'styled-components';

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

import {
    getColor,
    getFontFamily,
    getFontSize,
    getLetterSpacing,
    getLineHeight,
} from '@process-advisor/process-miner/shared/theme';

const RadioComponent = styled(Radio)<{ checked?: boolean }>`
    color: ${({ checked }) =>
        checked
            ? getColor('lightBlue')
            : getColor('lightBorderColor')};
    height: 25px;
    & .MuiSvgIcon-root {
        width: 17px;
        height: 17px;
    }
`;

const StyledFormControlLabel = styled(FormControlLabel)`
    margin-right: 15px;
    height: 25px;

    & .MuiFormControlLabel-label {
        color: ${getColor('inputTextColor')};
        font-size: ${getFontSize('smaller')};
        letter-spacing: ${getLetterSpacing('small')};
        line-height: ${getLineHeight('small')};
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;
const Wrapper = styled.div`

`;

export const SelectAction = () => {
    const [value, setValue] = React.useState('animate');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        const selectAction = (event.target as HTMLInputElement).value;
        setValue(selectAction);
        apiProvider.changeSelectAction({
            isolate: selectAction === 'isolate',
            animate: selectAction === 'animate',
            lifecycle: selectAction === 'lifecycle',
        });
    };

    return (
        <Wrapper>
            <RadioGroup
                row
                aria-label="selectAction"
                name="selectAction"
                value={value}
                onChange={handleChange}>
                <StyledFormControlLabel
                    value="animate"
                    control={<RadioComponent />}
                    label="Animate" />
                <StyledFormControlLabel
                    value="isolate"
                    control={<RadioComponent />}
                    label='Isolate' />                    
                <StyledFormControlLabel
                    value="lifecycle"
                    control={<RadioComponent />}
                    label="Lifecycle" />
            </RadioGroup>
        </Wrapper>
    );
};
